import React from "react";

import {XIterableElement} from './XIterableElement';
import styles from './styles/XTable.module.scss';

export interface ITableItem {}
export interface ITableRowItem {}

export interface ITableCellProps {
    class?: string | null;
    children? : React.ReactNode;
    height?: string;
    width?: string;
    image?: string;
    repeat?: string;
}

export interface ITableCellState {
}

export class XTableCell extends React.Component<ITableCellProps, ITableCellState> implements ITableRowItem {
    render() : React.ReactNode
    {
        return <div className={styles.XTableCell} style={{height: this.props.height, width: this.props.width, backgroundImage: this.props.image, backgroundRepeat: this.props.repeat}}>{this.props.children}</div>;
    }
}


export interface ITableRowProps {
    class?: string | null;
    children? : XIterableElement<ITableRowItem>;
    height?: string;
    width?: string;
}

export interface ITableRowState {
}

export class XTableRow extends React.Component<ITableRowProps, ITableRowState> implements ITableItem {
    render() : React.ReactNode
    {
        return <div className={styles.XTableRow} style={{height: this.props.height, width: this.props.width}}>{this.props.children}</div>;
    }
}

export interface ITableProps {
    class?: string | null;
    children? : XIterableElement<ITableItem>;
    height?: string;
    width?: string;
}
export interface ITableState {

}
export class XTable extends React.Component<ITableProps, ITableState> {
    render() : React.ReactNode
    {
        return <div className={styles.XTable} style={{height: this.props.height, width: this.props.width}}>{this.props.children}</div>;
    }
}